export default __webpack_public_path__ + "static/media/Notebook.fd49d017.svg";